import { CommonConstants } from './../utilities/commonConstants';
import { Injectable } from '@angular/core';
import { RouteContextProvider } from '../services/routeContextProvider.service';
import { Formatter } from './../services/formatter';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ClevertapEventHandlerService } from './clevertap-event-handler.service';
const TaskKeyArray = {
    revampvehicledetailsx: CommonConstants.Routes.Application.VehicleRegistration,
    quotecriteria: CommonConstants.Routes.Application.VehicleRegistration,
    prevpolicydet: CommonConstants.Routes.Application.Previouspolicydetail,
    productlisting: CommonConstants.Routes.PlanListing.PlanProductListing,
    editncbdetails: CommonConstants.Routes.PlanListing.PlanProductListing,
    assetdetail: CommonConstants.Routes.Application.VehicleDetails,
    additionalpolicydetails: CommonConstants.Routes.Application.AdditionalPolicyDetails,
    proposerdetails: CommonConstants.Routes.Application.OwnerDetails,
    permanentaddressdetails: CommonConstants.Routes.Application.AddressDetails,
    revamprenewalmobileverification: CommonConstants.Routes.Application.RenewVerifyMobile,
    revamprollovermobileverification: CommonConstants.Routes.Application.RenewVerifyMobile,
    revampcallbackpage: CommonConstants.Routes.Application.PaymentFailed,
    revamppolicypage: CommonConstants.Routes.Application.Congratulations,
    revampvehiclereject: CommonConstants.Routes.Reject,
    revampnonstp: CommonConstants.Routes.NonStp,
    emiotppage: CommonConstants.Routes.otp,
    multitabfailed: CommonConstants.Routes.MultitabFailed,
    tpnonstp: CommonConstants.Routes.NonStp,
    revampcommercialnonstp: CommonConstants.Routes.Application.VehicleRegistration,
    inspolicypage: CommonConstants.Routes.FinalModule.Congratulations,
    retrypaymentpage: CommonConstants.Routes.FinalModule.PaymentFailed,
    resumeotppage: CommonConstants.Routes.CustomerLogin,
    customerlogin: CommonConstants.Routes.CustomerLogin,
    vehicledetpage: CommonConstants.Routes.Application.MotorDetails,
    productsummarydetail: CommonConstants.Routes.FinalModule.ProductReview,
    nomineedetails: CommonConstants.Routes.Application.nomineeDetails,
    pendingpaymentpage: CommonConstants.Routes.FinalModule.PaymentFailed,
    inprogress: CommonConstants.Routes.FinalModule.PaymentStatus
};
@Injectable({
    providedIn: 'root'
})
export class RouteHandlerService {
    public Route: string = null;
    public NextTaskKey: string = null;
    public ExceptionKeyArr: any[];
    private taskKeyArray = TaskKeyArray;
    constructor(
        private _routeContextProvider: RouteContextProvider,
        private _formatter: Formatter,
        private activatedRoute: ActivatedRoute,
        public _cleverTapService: ClevertapEventHandlerService
    ) { }
    public RouteToNextTask(nextTaskKey: string, exceptionKeysArr?: any, callback?: any, toReload?: boolean) {
        const varAuthType = window['varAuthType'];

        this.Route = this.fetchRouteFromNextakKey(nextTaskKey);
        if (exceptionKeysArr && exceptionKeysArr.length > 0 && callback) {
            this.checkExceptionKeys(exceptionKeysArr, callback);
        } else if (callback) {
            callback(this.Route);
        } else if (this.Route) {
            this._routeContextProvider.NavigateToView([this.Route]);
            if (toReload) {
                const pathname = window.location.pathname;
                const newLocation = window.location.origin + pathname + '#/' + this.Route;
                location.replace(newLocation);
                location.reload();
            }
        } else {
            console.error('ERROR:: Route not available.');
        }
    }
    private fetchRouteFromNextakKey(nextTaskKey: string): string {
        this.NextTaskKey = this._formatter.toSmallCase(nextTaskKey);
        return this.taskKeyArray[this.NextTaskKey] || '';
    }
    private checkExceptionKeys(exceptionKeysArr, callback: any) {
        let toRoute = false;
        this.ExceptionKeyArr = exceptionKeysArr;
        for (let key of this.ExceptionKeyArr) {
            key = this._formatter.toSmallCase(key);
            if (this.NextTaskKey === key) {
                toRoute = false;
                callback(this.Route);
                break;
            } else {
                toRoute = true;
            }
        }
        if (toRoute) {
            this._routeContextProvider.NavigateToView([this.Route]);
        }
    }
    // Invoke via call method
    public GetQueryParams(key: string): string {
        let result;
        this.activatedRoute.queryParams.forEach((params) => {
            result = params[key] || CommonConstants.DEFAULT_EMPTY_STRING;
        });
        return result;
    }
}
